import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { DashboardResponse, DashboardCreateRequest, DashboardUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper } from '../utils';
import { DashboardDetailsSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { HealthIssueService } from '../healthissues/healthissue.service';
import { DomSanitizer } from '@angular/platform-browser';
import { buildLogsSectionGroup } from '../shared/feed.section';

@RegisterEntityHandler('dashboard')
@Injectable()
export class DashboardHandler extends EntityHandler<DashboardResponse> {

    constructor(
        admin: AdminEditorService,
        private issues: HealthIssueService,
        private sanitizer: DomSanitizer
    ) {
        super(admin);
    }

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listDashboards/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listDashboards(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'dashboard',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.DASHBOARDS'),
        }));
    }

    getEntity(id: string): Promise<DashboardResponse> {
        return this.admin.getCached(`getDashboard/${id}`, api => api.entities.getDashboard(id), 10);
    }

    createEntity(ownerId: string, entity: DashboardCreateRequest): Promise<DashboardResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createDashboard(entity), { _type: 'dashboard' });
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return state === 'deleted' ? this.admin.applyUpdate(api => api.entities.deleteDashboard(entity.id), { _type: 'dashboard' }) : Promise.reject('Only deletion supported');
    }

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.DASHBOARD.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', ICONS.dashboard),
            grid.TextColumn('description', 'DESCRIPTION'),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    async getEditorSections(ownerId: string, entity: DashboardResponse): Promise<SectionHandlerGroup<DashboardResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new DashboardDetailsSectionHandler(this.admin, ownerId),
            ],
            warnings: entity ? (await this.issues.getIssuesForEntity(ownerId, entity.id, 5)).map(issue => {
                return this.sanitizer.bypassSecurityTrustHtml(`<strong>${issue.sourceName}</strong><br>${issue.description}<br><a href="/#/admin/client/${entity.owner.id}/healthissues/grid/healthissue/${issue.id}">More</a>`);
            }) : [],
        },
        this.admin.user.owner.type === 'system' && buildLogsSectionGroup(this.admin, 'dashboard'),
        ].filter(x => x));
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: DashboardUpdateRequest, sections: FormSectionHandler<DashboardResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'dashboard',
            entity: {}, // set up some defaults if you want
            sections: [
                new DashboardDetailsSectionHandler(this.admin, ownerId),
            ],
        });
    }

}












